import { render } from "./HeroBlog.vue?vue&type=template&id=0357d89f&scoped=true"
import script from "./HeroBlog.vue?vue&type=script&lang=js"
export * from "./HeroBlog.vue?vue&type=script&lang=js"

import "./HeroBlog.vue?vue&type=style&index=0&id=0357d89f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0357d89f"]])

export default __exports__